import { Signal } from 'typed-signals';

export enum ProgressManagerEvent {
  Progress = 'ProgressManagerEventProgress',
  Complete = 'ProgressManagerEventComplete',
  Start = 'ProgressManagerEventStart',
}

export type ProgressManagerEventType = {
  progress: number;
  current: number;
  total: number;
};

export class ProgressMamager {
  private _current: number;
  private _total: number;

  updateSignal = new Signal<
    (type: ProgressManagerEvent, value: ProgressManagerEventType) => void
  >();

  constructor() {
    this.clear();
  }

  get progress(): number {
    if (this._total === 0) return 0;

    return this._current / this._total;
  }

  clear(): void {
    this._current = 0;
    this._total = 0;
  }

  incTotal(): void {
    this._total += 1;
  }

  incProgress(): void {
    this._current += 1;
    this.updateSignal.emit(ProgressManagerEvent.Progress, {
      progress: this.progress,
      total: this._total,
      current: this._current,
    });
    if (this.progress === 1) {
      this.updateSignal.emit(ProgressManagerEvent.Complete, {
        progress: this.progress,
        total: this._total,
        current: this._current,
      });
    }
  }
}
